import { render, staticRenderFns } from "./SummaryStep.vue?vue&type=template&id=96137e94"
import script from "./SummaryStep.vue?vue&type=script&lang=js"
export * from "./SummaryStep.vue?vue&type=script&lang=js"
import style0 from "./SummaryStep.vue?vue&type=style&index=0&id=96137e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports